/**
 * A token error occurred.
 */
export class TokenError extends Error {
  constructor(message: string) {
    super(message)
    this.name = "TokenError"
  }
}
